import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import WorkerLoadListAnalysisReportActions from '../../Stores/WorkerLoadListAnalysisReport/Actions';

const { Panel } = Collapse;

class WorkerLoadListAnalysisReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initWorkerLoadListAnalysis } = this.props;

    if (curSiteFlowId > 0) {
      initWorkerLoadListAnalysis();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initWorkerLoadListAnalysis } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initWorkerLoadListAnalysis();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'worker_load_list_analysis_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

WorkerLoadListAnalysisReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initWorkerLoadListAnalysis: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

WorkerLoadListAnalysisReportScreen.defaultProps = {
  intl: {},
  match: {},

  initWorkerLoadListAnalysis: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initWorkerLoadListAnalysis: () =>
    dispatch(
      WorkerLoadListAnalysisReportActions.workerLoadListAnalysisReportInitWorkerLoadListAnalysis()
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(WorkerLoadListAnalysisReportScreen));
